import React from 'react';
import PropTypes from 'prop-types';
import { Box, Heading, Panel, PanelHeader, PanelFooter } from 'rebass';
import { withStateHandlers } from 'recompose';
import InputField from '../../app/components/input_field';
import InputGroup from '../../app/components/input_group';
import Button from '../../app/components/button';
import CloseButton from '../../app/components/close_button';

const Form = ({ close, action, form, setValue }) => (
  <Panel style={{ border: 'none' }}>
    <PanelHeader
      color="greyLight"
      bg="greyExtraLight"
      px={4}
      py={3}
    >
      <Heading color="black">
        Let&apos;s begin!
      </Heading>
      <CloseButton
        onClick={close}
        top
        right
        mt={3}
        mr={3}
      />
    </PanelHeader>
    <form
      name="contact"
      action={action}
      method="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
    >
      <Box
        px={4}
        py={4}
        f={4}
      >
        <InputGroup>
          <InputField
            id="name"
            label="What's your name*"
            required
            value={form.name}
            placeholder="First and last name"
            onChange={value => setValue('name', value)}
          />
          <InputField
            id="email"
            label="What's your email address*"
            type="email"
            required
            value={form.email}
            placeholder="example@domain.com"
            onChange={value => setValue('email', value)}
          />
          <InputField
            id="work_type"
            label="What type of work do you need"
            value={form.workType}
            placeholder={'e.g. Work in Financial industry, Mobile App'}
            onChange={value => setValue('workType', value)}
          />
          <InputField
            id="budget"
            label="What's your budget"
            value={form.budget}
            placeholder={'$'}
            onChange={value => setValue('budget', value)}
          />
          {/* Hidden fields */}
          <div hidden>
            <InputField
              id="form-name"
              type="hidden"
              name="form-name"
              value="contact"
            />
            <InputField
              id="bot-field"
              name="bot-field"
            />
          </div>
        </InputGroup>
      </Box>
      <PanelFooter
        color="greyLight"
        bg="greyExtraLight"
        px={4}
        py={3}
      >
        <Button
          type="submit"
          bg="brand"
          f={3}
        >
          Submit
        </Button>
      </PanelFooter>
    </form>
  </Panel>
);

Form.propTypes = {
  close: PropTypes.func,
  action: PropTypes.string.isRequired,
  form: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    workType: PropTypes.string,
    budget: PropTypes.string,
  }).isRequired,
  setValue: PropTypes.func.isRequired,
};

Form.defaultProps = {
  close: null,
};

export default withStateHandlers(
  {
    form: {
      name: '',
      email: '',
      workType: '',
      budget: '',
    },
  },
  {
    setValue: ({ form }) => (key, value) => ({
      form: {
        ...form,
        [key]: value,
      },
    }),
  },
)(Form);



// WEBPACK FOOTER //
// ./src/Lead/form/index.js